import type { AppCapability } from '../components/AppManagementShell';

/**
 * §S7-WORKSPACE-LANE — the Owner Workspace's capability from the lane the SERVER built the app on.
 *
 * Measured in production (Session 7, as owner-a): the workspace guessed the capability from the app's prompt
 * words, and the guess overrode what the server already knew. A class-attendance tracker ("I want to book
 * them", trackers lane) was titled "Manage bookings" and mounted booking, customer and availability panels for
 * bookings that do not exist; a bike-shop parts inventory and a vinyl collection ("record shop") were titled
 * "Products & orders". `/v1/creator/apps/:id` returns `lanes.primary`, the lane the app is served on; a known
 * lane decides. An unknown lane, or an app the server built no descriptor for, keeps the keyword fallback.
 */
const LANE_CAPABILITY: Readonly<Record<string, AppCapability>> = {
  booking: 'booking',
  shop: 'commerce',
  orderahead: 'orderahead',
  crm: 'crm',
  smartcrm: 'crm',
  directory: 'directory',
  inventory: 'inventory',
  events: 'events',
  ticketing: 'ticketing',
  quizzes: 'quizzes',
  hr: 'hr',
  // personal records: the owner has no business console for a person's own entries
  trackers: 'tracker',
  workout: 'tracker',
  todo: 'tracker',
  expense: 'tracker',
  flashcards: 'tracker',
  // the collections lane has its own owner catalog console (lanes.ownerConsoles); a tracker stub would contradict it
  collections: 'generic',
  ops: 'generic',
};

export function capabilityForLane(primary: string | null | undefined): AppCapability | null {
  return primary ? LANE_CAPABILITY[primary] ?? null : null;
}
